import { render } from "./Equipped.vue?vue&type=template&id=67b2bfde"
import script from "./Equipped.vue?vue&type=script&lang=js"
export * from "./Equipped.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__